import useWindowDimensions from "../../hooks/useWindowDimensions";
import Matches from "./matches/matches";
import { useCallback, useEffect, useMemo, useState } from "react";
import Groups from "./groups/groups";
import Teams from "./teams/teams";
import Locations from "./locations/locations";
import SettingsView from "./settings/settings";
import { ROUTES } from "../../constants";
import { useLocation, useNavigate } from "react-router-dom";
import { TopNav } from "./components/top-nav";
import { SideNav } from "./components/side-nav";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import Puljer from "./puljer/puljer";
import CreateGroup from "./groups/createGroup";
import CreateTeam from "./teams/createTeam";
import CreateLocation from "./locations/createLocation";
import CreatePulje from "./puljer/createPulje";
import KnockOut from "./knockout/knockout";
import GenerateTournament from "./matches/generateTournament";
import CreateMatch from "./matches/createMatch";
import CreateTournamentEvent from "./matches/createTournamentEvent";
import { useAppSelector } from "../../hooks";
import Login from "../../components/login";
import { ROLES } from "../../types/types";
import NotificationService from "../../components/notification/NotificationService";
import TableView from "./table/table";
import Seeding from "./seeding/seeding";
import EditMatch from "./matches/editMatch";
import { Players } from "./players/players";
import { Referees } from "./referees/referees";
import CreateReferee from "./referees/createReferee";

const SIDE_NAV_WIDTH = 280;

const LayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  [theme.breakpoints.up("lg")]: {
    paddingLeft: SIDE_NAV_WIDTH,
  },
}));

const LayoutContainer = styled("div")({
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
});

function Admin() {
  const { isDesktop } = useWindowDimensions();
  const [openNav, setOpenNav] = useState(false);
  const pathname = useLocation().pathname;
  const admin = useAppSelector((state) => state.app.admin);
  const location = useLocation();

  const navigate = useNavigate();

  const getView = () => {
    switch (location.pathname) {
      case ROUTES.ADMIN:
        return <Matches />;
      case ROUTES.ADMIN_MATCHES:
        return <Matches />;
      case ROUTES.ADMIN_CREATE_MATCH:
        return <CreateMatch />;
      case ROUTES.ADMIN_CREATE_TOURNAMENT_EVENT:
        return <CreateTournamentEvent />;
      case ROUTES.ADMIN_EDIT_MATCH:
        return <EditMatch />;
      case ROUTES.ADMIN_GENERATE_TOURNAMENT:
        return <GenerateTournament />;
      case ROUTES.ADMIN_PULJER:
        return <Puljer />;
      case ROUTES.ADMIN_CREATE_PULJE:
        return <CreatePulje />;
      case ROUTES.ADMIN_GROUPS:
        return <Groups />;
      case ROUTES.ADMIN_CREATE_GROUP:
        return <CreateGroup />;
      case ROUTES.ADMIN_TEAMS:
        return <Teams />;
      case ROUTES.ADMIN_CREATE_TEAM:
        return <CreateTeam />;
      case ROUTES.ADMIN_KNOCK_OUT:
        return <KnockOut />;
      case ROUTES.ADMIN_LOCATIONS:
        return <Locations />;
      case ROUTES.ADMIN_CREATE_LOCATION:
        return <CreateLocation />;
      case ROUTES.ADMIN_SETTINGS:
        return <SettingsView />;
      case ROUTES.ADMIN_TABLE:
        return <TableView />;
      case ROUTES.ADMIN_SEEDING:
        return <Seeding />;
      case ROUTES.ADMIN_TOPSCORE:
        return <Players />;
      case ROUTES.ADMIN_REFEREES:
        return <Referees />;
      case ROUTES.ADMIN_CREATE_REFEREE:
        return <CreateReferee />;
      default:
        return <h1>404 page does not exist</h1>;
    }
  };

  const handlePathnameChange = useCallback(() => {
    if (openNav) {
      setOpenNav(false);
    }
  }, [openNav]);

  useEffect(() => {
    handlePathnameChange();
  }, [pathname]);

  const isValidAdmin = useMemo(() => {
    switch (admin?.role) {
      case ROLES.SUPER_ADMIN:
        return true;
      case ROLES.ADMIN:
        return true;
      case ROLES.EDITOR:
        NotificationService.showToast({ text: "You do not have sufficient access to this page", severity: "error" });
        return false;
      default:
        return false;
    }
  }, [admin?.role]);

  return (
    <>
      {!isValidAdmin ? (
        <Login open={true} returnCallback={() => { }} />
      ) : (
        <div style={{ width: "100%", height: "100%", minHeight: "100vh", backgroundColor: "white" }}>
          <TopNav onNavOpen={() => setOpenNav(true)} />
          <SideNav adminType="ADMIN" onClose={() => setOpenNav(false)} open={openNav} />
          <LayoutRoot>
            <LayoutContainer>
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                }}
              >
                {getView()}
              </Box>
            </LayoutContainer>
          </LayoutRoot>
        </div>
      )}
    </>
  );
}

export default Admin;
